require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./procdure-dadmission-au-bachelor-2-6-1.json") })
        }
      }, "path---procdure-dadmission-au-bachelor-2-6-1");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---procdure-dadmission-au-bachelor-2-6-1!./.cache/json/procdure-dadmission-au-bachelor-2-6-1.json
// module id = 534
// module chunks = 231608221292675